import { pinyin } from "pinyin-pro";


const _pinyin = (str) => {
  const reg = /[\u4e00-\u9fa5]/g;

  return str.replace(reg, $1 => {
    const s = pinyin($1, { toneType: 'none' });
    return s[0].toUpperCase() + s.slice(1);
  })
}

export default _pinyin;